/**
 * 多次散射接口与类型（对应需求优先级 1.7）。
 * Phase A：仅提供类型桩与模式索引；Phase D 实现 secondOrder 与 precomputedLUT。
 */

export type ScatteringMode = 'single' | 'secondOrder' | 'precomputedLUT'

export interface MultipleScatteringParams {
  mode: ScatteringMode
  /** 散射阶数 */
  order: number
  /** 强度 0-1 */
  intensity: number
}

/**
 * 多次散射可插拔接口（对应需求伪代码，作为 API 文档）。
 * 实际实现位于着色器内（atmosphere.glsl.ts 的 computeSecondOrder + MultiScatterLUT）。
 */
export interface IMultipleScattering {
  mode: ScatteringMode
  /** 返回沿视线方向的内散射增量（RGB） */
  computeInScattering(
    rayOrigin: number[],
    rayDir: number[],
    sunDir: number[],
    params: MultipleScatteringParams,
  ): number[]
}

/** 着色器 uniform 中使用的模式整数索引 */
export const SCATTERING_MODE_INDEX: Record<ScatteringMode, number> = {
  single: 0,
  secondOrder: 1,
  precomputedLUT: 2,
}
